import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Snackbar } from '@mui/material';
import { hideSnackbar } from '../store/snackbarSlice/snackbarSlice';

/**
 *  const { open, message, autoHideDuration } = useSelector((state) => state.snackbar);
 *  const dispatch = useDispatch();
 *
 */

const SnackbarComponent = () => {
  const { open, message, autoHideDuration, anchorOrigin } = useSelector((state) => state.snackbar);
  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(hideSnackbar());
  };

  return (
    <>
      <Snackbar
        open={open}
        message={message}
        autoHideDuration={autoHideDuration}
        onClose={handleClose}
        anchorOrigin={anchorOrigin}
      />
    </>
  );
};

export default SnackbarComponent;
